<template>
  <div class="status-box">
    <!-- 个人赛答题 -->
    <template v-if="question_status === 0">
      <div class="status-title">个人赛答题</div>
      <img src="../../assets/images/success.png" width="240" alt="">
      <p class="color_primary"><strong>请点击按钮进入答题环节</strong></p>
      <div class="team-button-box">
          <el-button class="pre" @click="toAnswer">前往答题</el-button>
      </div>
    </template>

    <!-- 通过 -->
    <template v-else-if="question_status === 1">
      <div class="status-title">个人赛答题</div>
      <img src="../../assets/images/pass.png" width="240" alt="">
      <p class="color_primary"><strong>恭喜你通过2026 GBC个人赛<br />证书请在CGMA小程序下载，将于4月25日线上赛结束后统一发放（约10个工作日）。</strong></p>

      <div class="question-success">
        <div class="qrcode-box">
          <div class="item">
            <img src="../../assets/images/qrcode1.png" alt="">
            <p class="is-small">扫码登录CGMA小程序<br />“我的”-“证书”查看</p>
          </div>
          <div class="item">
            <img src="../../assets/images/share-qrcode.png" alt="">
            <p class="is-small">微信扫一扫<br />即可分享此喜讯</p>
          </div>
        </div>
      </div>
      <div class="question-success bg_primary">
        <div class="text">获取线上案例赛背景及题目文件</div>
        <el-button size="small" plain @click="toDownload">点击下载</el-button>
      </div>
      <div class="team-button-box">
          <el-button class="next" @click="nextStep" :loading="submitLoading">下一步</el-button>
          <!-- <el-button class="cancel">取消</el-button> -->
      </div>
    </template>

    <!-- 未通过 -->
    <template v-else-if="question_status === -1">
      <div class="status-title">个人赛答题</div>
      <img src="../../assets/images/fail.png" width="240" alt="">
      <p>很遗憾 你没有通过2026 GBC个人赛</p>
    </template>
  </div>

</template>

<script>
import { apiGetAnswerLink, apiGetSubPersonalInfo, apiSetProcess } from '../../plugins/apis';

export default {
  // 组件参数 接收来自父组件的数据
  // 局部注册的组件
  components: {},
  // 组件状态值
  data() {
    return {
      url: '',
      question_status: null,
      submitLoading: false
    }
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
  // 组件方法
  methods: {
    toAnswer(){
      location.href = this.url  
    },
    async getUrl() {
      // 获取答题链接
      const res = await apiGetAnswerLink()
      if (res.code === 200) {
        this.url = res.data.url
      }
    },
    async getPersonalInfo() {
      const res = await apiGetSubPersonalInfo()
      if(res.code === 200) {
        this.question_status = res.data.data.question_status
        if(res.data.data.question_status === 0) {
          this.getUrl()
        }
      }
    },
    toDownload() {
      const link = document.createElement('a');
      link.href = 'https://api.gbc.cncima.com/storage/线上案例赛背景及题目文件.zip';
      link.download = '线上案例赛背景及题目文件.zip';
      link.click();
      link.remove();
    },
    async nextStep() {
      this.submitLoading = true
      await apiSetProcess(this.round.round_id,this.label)
      setTimeout(() => {
        this.$Bus.$emit("reload_NowProcess")
        this.submitLoading = false
      }, 1000);
    }
  },
  props:['round','label'],
  async mounted() {
    await this.getPersonalInfo()
  },
}
</script>

<style scoped></style>
